// 有背景颜色的勾选图标
export const StatusIcon = (props: { x?: boolean }) => {
  if (props.x) {
    return (
      <svg
        className="flex-shrink-0"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.9697 15.0303C14.2626 15.3232 14.7374 15.3232 15.0303 15.0303C15.3232 14.7374 15.3232 14.2626 15.0303 13.9697L11.0607 10L15.0303 6.03033C15.3232 5.73744 15.3232 5.26256 15.0303 4.96967C14.7374 4.67678 14.2626 4.67678 13.9697 4.96967L10 8.93934L6.03033 4.96967C5.73744 4.67678 5.26256 4.67678 4.96967 4.96967C4.67678 5.26256 4.67678 5.73744 4.96967 6.03033L8.93934 10L4.96967 13.9697C4.67678 14.2626 4.67678 14.7374 4.96967 15.0303C5.26256 15.3232 5.73744 15.3232 6.03033 15.0303L10 11.0607L13.9697 15.0303Z"
          fill="#B5260B"
        />
      </svg>
    )
  }
  return (
    <svg
      className="flex-shrink-0"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="10" fill="#fff" />
      <rect x="2" y="2" width="16" height="16" rx="8" fill="#fff" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8162 6.20701C16.0701 6.47369 16.0597 6.89568 15.793 7.14954L8.08929 14.4829C7.95773 14.6081 7.78078 14.6742 7.59933 14.666C7.41788 14.6577 7.24766 14.5758 7.12803 14.4391L4.16506 11.0545C3.92254 10.7775 3.95052 10.3563 4.22755 10.1138C4.50459 9.87125 4.92577 9.89923 5.16829 10.1763L7.67342 13.0379L14.8737 6.1838C15.1404 5.92994 15.5624 5.94033 15.8162 6.20701Z"
        fill="#298177"
      />
    </svg>
  )
}
